export const useEcgCanvas = {
  methods: {
    initCanvas(canvasId, width, height) {
      const canvas = document.getElementById(canvasId)
      if (!canvas) {
        console.error(`Canvas with id ${canvasId} not found`)
        return null
      }
      const ctx = canvas.getContext('2d')
      canvas.width = width
      canvas.height = height
      return { canvas, ctx }
    },
    drawGrid(ctx, width, height, scaleX, scaleY, pointOfTime = []) {
      const d = 20
      const offsetx = 0
      const offsety = 0

      ctx.clearRect(0, 0, width, height)

      for (let i = 0; i <= width / d; i++) {
        ctx.strokeStyle = 'rgba(255,0,0,.2)'
        ctx.lineWidth = 1
        ctx.beginPath()
        ctx.moveTo(i * d + offsetx + 0.5, offsety)
        ctx.lineTo(i * d + offsetx + 0.5, height + offsety)
        ctx.stroke()
      }

      for (let j = 0; j <= height / d; j++) {
        ctx.strokeStyle = 'rgba(255,0,0,.2)'
        ctx.lineWidth = 1
        ctx.beginPath()
        ctx.moveTo(offsetx, j * d + offsety + 0.5)
        ctx.lineTo(width - offsetx, j * d + offsety + 0.5)
        ctx.stroke()
      }

      ctx.fillStyle = 'rgba(255,0,0,.5)'
      for (let i = 0; i <= width / 4; i++) {
        for (let j = 0; j <= height / 4; j++) {
          const x = offsetx + i * 4
          const y = j * 4
          if (x % 10 !== 0 && y % 10 !== 0) {
            ctx.fillRect(offsetx + i * 4, j * 4, 1, 1)
          }
          if ((x - offsetx === 0 || (x - offsetx) % 100 === 0) && (y === 0 || y % 100 === 0)) {
            const xPoint = offsetx + (i * (4 * scaleX)) / 25
            const yPoint = (j * (4 * scaleY)) / 10
            ctx.fillRect(xPoint - 0.5, yPoint - 0.5, 2, 2)
            if (j === 0) {
              pointOfTime.push(xPoint)
            }
          }
        }
      }
    }
  }
}
